import queryString from "query-string";
import ApiService from "./ApiService";

// Notifications
export async function apiGetNotificationList(data) {
  return ApiService.fetchData({
    url: `Notification/List?${queryString.stringify(data, { skipNull: true })}`,
    method: "get",
  });
}
export async function apiGetNotification(data) {
  return ApiService.fetchData({
    url: `Notification/Get?id=${data}`,
    method: "get",
  });
}
export async function apiPostNotification(data) {
  return ApiService.fetchData({
    url: `Notification/Upsert`,
    method: "post",
    data,
  });
}
export async function apiDeleteNotification(data) {
  return ApiService.fetchData({
    url: `Notification/Delete?id=${data}`,
    method: "delete",
  });
}

export async function apiReadNotification(data) {
  return ApiService.fetchData({
    url: `Notification/Read`,
    method: "post",
    data,
  });
}

export async function apiGetMyNotificationList(data) {
  return ApiService.fetchData({
    url: `Notification/MyNotifications?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "get",
  });
}
